import React, { ReactNode } from 'react';
import { motion } from 'framer-motion';
interface FadeInProps {
  children: ReactNode;
  delay?: number;
  className?: string;
  direction?: 'up' | 'none';
}
export function FadeIn({
  children,
  delay = 0,
  className = '',
  direction = 'up'
}: FadeInProps) {
  return <motion.div initial={{
    opacity: 0,
    y: direction === 'up' ? 30 : 0
  }} whileInView={{
    opacity: 1,
    y: 0
  }} viewport={{
    once: true,
    margin: '-100px'
  }} transition={{
    duration: 0.9,
    ease: [0.21, 0.47, 0.32, 0.98],
    delay
  }} className={className} data-id="element-299" data-mp="39bc7wi2q1uxz">
      {children}
    </motion.div>;
}